import { Container, Plugins, SectionTitle } from '@sloyd/ui';
import { Wrapper } from './ContentPlugins.style';

export type ContentPluginsProps = {};

export function ContentPlugins(_props: ContentPluginsProps) {
  return (
    <Wrapper className='ContentPlugins-wrapper' data-testid='ContentPlugins-wrapper'>
      <SectionTitle gradient={{ from: '#6a11cb', to: '#fff' }} title='Tools'>
        Enhance your workflow with powerful plugins for Sloyd.
      </SectionTitle>
      <Container>
        <Plugins />
      </Container>
    </Wrapper>
  );
}

export default ContentPlugins;
